import React from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';

interface TextLabelProps {
  label: string;
  children: React.ReactNode;
  disabled?: boolean;
}

const TextLabelBlock = styled(Box)`
  padding: ${(props) => props.theme.spacing(0.5, 1)};
  word-break: break-word;
`;

const TextWithLabel = ({ children, label, disabled }: TextLabelProps) => {
  const labelColor = disabled ? 'textSecondary' : 'primary';
  const contentColor = disabled ? 'textSecondary' : 'textPrimary';

  return (
    <TextLabelBlock>
      <Typography variant="caption" component="h6" color={labelColor}>
        {label}
      </Typography>
      <Typography variant="body2" color={contentColor}>
        {children}
      </Typography>
    </TextLabelBlock>
  );
};

export default TextWithLabel;
